import React from "react";
import BaseGrid from "Components/Fragment/BaseGrid";
import SelectFilter from "./SelectFilter";
import { useMyLearning } from "../../../context";

const SelectFilterTags = ({ setTagFilter, languageContext, sx }) => {
  const { tags, filter } = useMyLearning();

  const handleChange = (index, value = 0) => {
    const parsed = parseInt(value, 10) || 0;
    setTagFilter(index, parsed);
  };

  return (
    <BaseGrid direction="column">
      {tags.map((tag, i) => (
        <SelectFilter
          fullWidth={true}
          key={tag.categoryId}
          name={languageContext(tag.title)}
          value={filter.selectedTags[i] ? String(filter.selectedTags[i]) : "0"}
          onChange={(value) => handleChange(i, value)}
          options={[
            { value: "0", label: languageContext("all") },
            ...tag.values.map((o) => ({
              value: o.valueId.toString(),
              label: o.title,
            })),
          ]}
          languageContext={languageContext}
          className="filter-select-category-tags"
          sx={sx}
        />
      ))}
    </BaseGrid>
  );
};

export default SelectFilterTags;
